import axios from "axios"

export default async function fetchEventOrg(orgId: string) {
    const { data } = await axios.get(
        `${process.env.NEXT_PUBLIC_API_URL}events/org/${orgId}`
    )
    return data
}
